import get from 'lodash.get';

const getCurrentTheme = (rootState) => get(rootState, 'ws.site.meta.currentTheme', null);

export default getCurrentTheme;
